var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';
import { styled } from '@material-ui/core/styles';
import { style, compose, sizing } from '@material-ui/system';
var textSize = style({
    prop: 'textSize',
    cssProperty: 'fontSize',
});
var StyledSvgIcon = styled(SvgIcon)(compose(textSize, sizing));
// naming convention based on fontsize css property
// small, large, and default based on original SvgIcon fontSizes
var IconSizes;
(function (IconSizes) {
    IconSizes["xxsmall"] = "0.75rem";
    IconSizes["xsmall"] = "1rem";
    IconSizes["smaller"] = "1.25rem";
    IconSizes["small"] = "1.4285714285714284rem";
    IconSizes["large"] = "2.5rem";
    IconSizes["default"] = "1.7142857142857142rem";
    IconSizes["inherit"] = "inherit";
})(IconSizes || (IconSizes = {}));
/**
 * Kareo wrapped component of the Material-UI Icon. The prop API has been limited to props defined in IconProps.
 *
 * Material-UI Icon: [Docs](https://v4.mui.com/components/icons/), [API](https://v4.mui.com/api/icon/)
 *
 * @storybook: [Icon](http://design.kareoprod.ent/?path=/story/design-system_components-data-display-icon--icon-list-story-book)
 */
var Icon = React.forwardRef(function (_a, ref) {
    var _b = _a.fontSize, fontSize = _b === void 0 ? 'default' : _b, props = __rest(_a, ["fontSize"]);
    var size = IconSizes[fontSize];
    return React.createElement(StyledSvgIcon, __assign({}, props, { textSize: size, ref: ref }));
});
Icon.displayName = 'KareoIcon';
export default Icon;
